import { PurlTrackingService } from "@/services/purlTracking.service";

export default {
  setPurlId({ commit }, purlId) {
    if (purlId) {
      commit("SET_PURL_ID", purlId);
    } else {
      commit(
        "toast/NEW",
        { type: "info", message: "No purl found" },
        { root: true }
      );
    }
  },
  setPurlInfo({ commit }, purlInfo) {
    commit("SET_PURL_INFO", purlInfo);
  },
  purlTracking({ state, commit, rootState }, label) {
    if (!label) return;
    PurlTrackingService.track(label, state?.id);
  },
};
